// extracted by mini-css-extract-plugin
module.exports = {"header":"i_P7","body":"i_P8","coach":"i_P9","footer-legal":"i_QA"};